<script>
import api from '@utils/api'
import userHasRolesToWrite from '@utils/userPermissions'

export default {
  name: 'Density',
  props: {
    characteristic: {
      type: Object,
      default: () => {
        return Object
      },
    },
  },
  data() {
    return {
      loading: false,
      valid: true,
      item: {
        density: null,
      },
      rolesAllowedToWrite: ['SUPERUSER', 'DICTIONARIES_OPERATOR'],
      rules: {
        isRequired: [x => !!x || this.$t('validation__is_required')],
      },
    }
  },
  computed: {
    userAllowedToUpdate() {
      return userHasRolesToWrite(
        this.$store.state.auth.userRole,
        this.rolesAllowedToWrite
      )
    },
  },
  watch: {
    characteristic: {
      handler(value) {
        this.ejectDensity()
      },
      deep: true,
    },
  },
  created() {
    this.ejectDensity()
  },
  methods: {
    ejectDensity() {
      const density = this.characteristic.content.find(
        item => item.characteristic === 121
      )
      this.item.density = density ? density.value : null
    },
    submit() {
      if (this.$refs.densityForm.validate()) {
        this.loading = true
        api
          .createSubItem('goods', this.$route.params.goodsId, 'oilcharacts', {
            density15c: this.item.density.replace(',', '.'),
          })
          .then(response => {
            this.$emit('characteristics-updated')
            this.loading = false
          })
          .catch(() => {})
          .then(() => {
            this.loading = false
          })
      }
    },
  },
}
</script>

<template>
  <v-container fluid>
    <v-layout wrap>
      <v-flex lg4>
        <v-form ref="densityForm" v-model="valid" lazy-validation>
          <v-text-field
            :label="$t('label__density_at_temperature')"
            :readonly="!userAllowedToUpdate"
            :rules="rules.isRequired"
            v-model="item.density"
            :hint="$t('label__g_to_cm')"
            persistent-hint
          />
        </v-form>
        <div :class="$style.btnWrapper">
          <v-btn
            v-if="userAllowedToUpdate"
            :disabled="loading"
            :loading="loading"
            :color="item.density ? 'success' : 'primary'"
            @click="submit"
          >
            {{ item.density ? $t('buttons__update') : $t('buttons__create') }}
          </v-btn>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<style lang="scss" module>
@import '@design';
.btnWrapper {
  margin-top: 26px;
  margin-left: -8px;
}
</style>
